import React, { useState, useEffect } from 'react';
import BuyBeltInit from '../../shims/buy-belt-init';
import Warning from '../../warning';

function ExpressDetails({
	details,
  fulfillmentDetails={},
  pricingDetails,
 	select=()=>{}
}) {
  const { itemOnSale, specialPrice, originalPrice, bodfsThresholdTotal } = pricingDetails;
	const displayedPrice = itemOnSale ? specialPrice : originalPrice;
	const quantityBoxSelectorInput = "#buybox__quantity__input";
	const [totalPrice, setTotalPrice] = useState(displayedPrice);
  useEffect(() => {
    BuyBeltInit.initHowItWorks()
    // return function cleanup() {};
  }, []);

  useEffect(() => {
		window.$(document).click(function (ev) {
			if (ev.target.id === "buybox__quantity__input" || ev.target.classList.contains("quantity-btn")) {
				setTotalPrice(displayedPrice*window.$(quantityBoxSelectorInput).val());
			}
		});
		window.$(quantityBoxSelectorInput).change(function () {
			setTotalPrice(displayedPrice*window.$(quantityBoxSelectorInput).val());
		});
		window.$(quantityBoxSelectorInput).ready(function () {
			setTotalPrice(displayedPrice*window.$(quantityBoxSelectorInput).val());
		});
  }, [window.$(quantityBoxSelectorInput).val()]);
  
  const isBodfsMinimumTotal = (totalPrice) => {
		const bodfsMinimum = pricingDetails &&  bodfsThresholdTotal ? bodfsThresholdTotal : 0;
		return totalPrice >= bodfsMinimum;
	}

	const bodfsThresholdMessaging = () => {
		return (
      <Warning>
        <span>There's a ${bodfsThresholdTotal} minimum purchase for Scheduled Delivery.</span>
      </Warning>
		)
	}

  const deliveryDay = (details.storeDeliveryTimeline==="today")?"Today":((details.storeDeliveryTimeline==="tomorrow")?"Tomorrow":"");
  const covidMessaging = fulfillmentDetails.showBodfsCovidAlert ?
      <span className="dai_detailsMessage">
        	Schedule delivery at checkout&nbsp;
      </span> :
      <span className="dai_detailsMessage">
        	Get it scheduled for delivery as soon as&nbsp;
          <span className="u__bold" data-automation-id="pickupDay">
      			{deliveryDay} &nbsp;
      		</span>
      </span>;
  if(deliveryDay){
    return (
      <div className="heading-message">
          {covidMessaging}
        <div>
  		    <a className="u__default-link how_it_works howItWorksReact" id="howItWorksReact">How It Works</a>
        </div>
        {!isBodfsMinimumTotal(totalPrice) &&
          bodfsThresholdMessaging()
        }
      </div>
    );
  }else{
    return (
      <div className="heading-message">
        <span className="dai_detailsMessage">
          Schedule Express Delivery at your convenience.&nbsp;
        </span>
        <div>
          <a className="u__default-link how_it_works howItWorksReact" id="howItWorksReact">How It Works</a>
        </div>
        {!isBodfsMinimumTotal(totalPrice) &&
          bodfsThresholdMessaging()
        }
      </div>
    );
  }
}

export default ExpressDetails;
